/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockRecipes
 * @description Data access service for managing stock recipes
 */
angular.module('mercury.modules.stock.recipe')
.factory('StockRecipes', ["$http", "$q", "$resource", "$timeout", "settings", function($http, $q, $resource, $timeout, settings) {
  var StockRecipes = $resource(settings.apiHost + '/r/StockRecipes/:id', {id: '@id'}, {update: {method: 'PUT'}, patch: {method: 'PATCH'}});
  var StockRecipeVersions = $resource(settings.apiHost + '/r/StockRecipeVersions/:id', {id: '@id'}, {update: {method: 'PUT'}});

  // Stock API endpoints
  var Recipes = $resource(settings.stockHost + '/internal/recipes/:id', {id: '@id'})
  var RecipeVersions =$resource(settings.stockHost + '/internal/recipe-versions/:id', {id: '@id'})

  /**
   * Get a summary of all recipes
   *
   * @memberof StockRecipes
   */
  function getAll() {
    return StockRecipes.query();
  }

  /**
   * Get all recipes via the Stock API
   *
   * @memberof StockRecipes
   */
  function getAllStockApi() {
    return Recipes.query();
  }

  /**
   * Get a summary of all active recipes
   *
   * @memberof StockRecipes
   */
  function getAllActive() {
    return StockRecipes.query({$filter: 'DatestampDeleted eq null'});
  }

  /**
   * Get all the images for a specific recipe
   *
   * @memberof StockRecipes
   * @param  {Object} recipe Recipe model
   */
  function getImages(recipe) {
    //Fetch images for the recipe.
    var fetchImage = function(image, recipeId) {
      return $http({
        url: settings.apiHost + '/r/Image/' + image.id + '?recipeId=' + recipeId,
        method: 'GET',
        responseType: 'text',
        params: {
          cropX: image.crop[0],
          cropY: image.crop[1],
          cropW: image.crop[4],
          cropH: image.crop[5]
        }
      });
    };

    var promises = [];

    var notesDoc = $('<div>').html(recipe.notes);
    notesDoc.find('img').each(function(index, elem) {
      //Images within the notes are stored without a src attribute. All informaiton needed to
      //fetch the image is held in the class tag of the parent span.
      var image;
      try {
        image = JSON.parse(decodeURIComponent($(elem).parent('span').attr('class')));
      }
      catch (e) {
        console.log(e);
        return;
      }

      var loadingImage = fetchImage(image, recipe.id);
      loadingImage.then(function(response) {
        $(elem).attr('src', 'data:image/png;base64,' + response.data);
        recipe.notes = notesDoc.html();
      });

      promises.push(loadingImage);
    });

    if (recipe.mainImageJson && recipe.mainImageJson !== 'null') {
      recipe.mainImageJson = JSON.parse(recipe.mainImageJson);
      var loadingImage = fetchImage(recipe.mainImageJson, recipe.id);
      loadingImage.then(function(response) {
        recipe.mainImageJson.src = 'data:image/png;base64,' + response.data;
      });

      promises.push(loadingImage);
    }

    return $q.all(promises);
  }

  /**
   * Get a specific recipe version
   *
   * @memberof StockRecipes
   * @param  {String} id Id of the recipe version
   */
  function getVersion(id) {
    return StockRecipeVersions.get({id: id});
  }

  /**
   * Get a specific recipe version via the Stock API
   *
   * @memberof StockRecipes
   * @param  {String} id Id of the recipe version
   */
    function getVersionStockApi(id) {
      return RecipeVersions.get({id: id});
    }

  /**
   * Get the full details of a specific recipe
   *
   * @memberof StockRecipes
   * @param  {String} id Id of the recipe
   * @param {Date} currentVersionBefore Date that the current version information
   *   returned should be based upon when there are versions of the recipe
   */
  function get(id, currentVersionBefore) {
    var result = $q.defer();

    StockRecipes.get(
      {id: id},
      function(recipe) {
        recipe.imagesJson = (recipe.imagesJson) ? JSON.parse(recipe.imagesJson) : [];

        var recipePromises = [];

        var beforeMoment = currentVersionBefore || moment();
        var currentVersionIndex = 0;
        if (recipe.versions.length > 1) {
          angular.forEach(recipe.versions, function(version, versionIndex) {
            if (version.validFrom === null || moment(version.validFrom).isBefore(beforeMoment)) {
              currentVersionIndex = versionIndex;
            }
          });
        }

        var currentVersionLoading = getVersion(recipe.versions[currentVersionIndex].id);
        currentVersionLoading.$promise.then(function(version) {
          recipe.versions[currentVersionIndex] = version;
        });
        recipePromises.push(currentVersionLoading.$promise);

        // Load recipe related images
        var imagesLoading = getImages(recipe);
        imagesLoading.catch(function(response) {
          // Suppress any image failed to load error messages.
          $timeout.cancel(response.defaultAlertTimeout);
        });

        recipePromises.push(imagesLoading);

        // We want to await all promises in the recipePromises array regardless
        // of whether or not any of them may reject hence we use $q.allSettled here.
        $q.allSettled(recipePromises)
        .then(function() {
          // We could iterate over the result here (first argument to this
          // function) and determine the result of each individual promise
          // but for our purposes we're ok with always resolving with the
          // recipe object being whatever it ended up being based on the
          // awaited promises that resolved successfully.
          result.resolve(recipe);
        });
      },
      function(response) {
        result.reject(response);
      }
    );

    return result.promise;
  }

  /**
   * Get a specific recipe via the Stock API
   *
   * @memberof StockRecipes
   * @param  {String} id Id of the recipe
   * @param {Date} currentVersionBefore Date that the current version information
   *   returned should be based upon when there are versions of the recipe
   */
  function getStockApi(id, currentVersionBefore) {
    var result = $q.defer()

    Recipes.get(
      {id: id},
      function(recipe) {
        recipe.imagesJson = (recipe.imagesJson) ? JSON.parse(recipe.imagesJson) : [];

        var recipePromises = [];

        var beforeMoment = currentVersionBefore || moment();
        var currentVersionIndex = 0;
        if (recipe.versions.length > 1) {
          angular.forEach(recipe.versions, function(version, versionIndex) {
            if (version.validFrom === null || moment(version.validFrom).isBefore(beforeMoment)) {
              currentVersionIndex = versionIndex;
            }
          });
        }

        // Load recipe related images
        var imagesLoading = getImages(recipe);
        imagesLoading.catch(function(response) {
          // Suppress any image failed to load error messages.
          $timeout.cancel(response.defaultAlertTimeout);
        });

        recipePromises.push(imagesLoading);

        // We want to await all promises in the recipePromises array regardless
        // of whether or not any of them may reject hence we use $q.allSettled here.
        $q.allSettled(recipePromises)
        .then(function() {
          // We could iterate over the result here (first argument to this
          // function) and determine the result of each individual promise
          // but for our purposes we're ok with always resolving with the
          // recipe object being whatever it ended up being based on the
          // awaited promises that resolved successfully.
          result.resolve(recipe);
        });
      },
      function(response) {
        result.reject(response);
      }
    );

    return result.promise;
  }

  function getCostAndUnit(id) {
    return StockRecipes.get({id: id}).$promise;
  }

  /**
   * Save details of a specific recipe version
   *
   * @memberof StockRecipes
   * @param  {Object} recipe     Recipe model
   * @param  {Object} version    Recipe version model
   * @param  {String} validUntil Valid until date if the version isn't the current one
   */
  function save(recipe, version, validUntil) {
    var recipeToSend = MapToWebApiRecipeModel(recipe);
    var versionToSend = MapToWebApiVersionModel(version);

    if (recipeToSend.mainImageJson) {
      delete recipeToSend.mainImageJson.src;
      recipeToSend.mainImageJson = JSON.stringify(recipeToSend.mainImageJson);
    }

    angular.forEach(recipeToSend.imagesJson, function(image) {
      delete image.src;
    });

    //Remove all the source tags in the notes images so we will reduce the amount stored in the database.
    //The html contains enough information to reterive the images on load.
    var notesDoc = $('<div>').html(recipeToSend.notes);
    notesDoc.find('img').each(function(index, elem) {
      $(elem).removeAttr('src');
    });
    recipeToSend.notes = notesDoc.html();
    recipeToSend.imagesJson = JSON.stringify(recipeToSend.imagesJson);

    delete recipeToSend.versions;

    versionToSend.recipe = recipeToSend;

    if (version.id) {
      return StockRecipeVersions.update({validUntil: validUntil}, versionToSend).$promise;
    } else {
      return StockRecipeVersions.save(versionToSend).$promise;
    }
  }

  /**
   * Internal method used to patch recipes
   *
   * @param  {String} recipeId Id of the recipe to patch
   * @param  {String} field    Field to update
   * @param  {String} newValue Updated value
   */
  function patch(recipeId, field, newValue) {
    var delta = [{op: 'replace', path: field, value: newValue}];

    return StockRecipes.patch({id: recipeId}, delta).$promise;
  }

  /**
   * Set a recipe as deleted
   *
   * @memberof StockRecipes
   * @param  {Object} recipe recipe model
   */
  function remove(recipe) {
    return patch(recipe.id, 'DatestampDeleted', moment().format());
  }

  /**
   * Set a recipe as not deleted
   *
   * @memberof StockRecipes
   * @param  {Object} recipe recipe model
   */
  function restore(recipe) {
    return patch(recipe.id, 'DatestampDeleted', null);
  }

  /**
   * Delete a recipe version
   *
   * @memberof StockRecipes
   * @param  {Object} version recipe version model to delete
   */
  function removeVersion(version) {
    var webApiVersion = MapToWebApiVersionModel(version)
    return StockRecipeVersions.delete({}, webApiVersion).$promise;
  }

  
  function MapToWebApiRecipeModel(stockApiRecipeModel) {
    var webApiModel = angular.copy(stockApiRecipeModel);

    webApiModel.datestampCreated = stockApiRecipeModel.createdAt
    webApiModel.datestampModified = stockApiRecipeModel.modifiedAt
    webApiModel.datestampDeleted = stockApiRecipeModel.deletedAt
    webApiModel.stocktake = stockApiRecipeModel.isCountedInStocktake
    // When creating a new recipe it has no versions, so need to cater for that
    webApiModel.versions = stockApiRecipeModel.versions 
      ? stockApiRecipeModel.versions.map(version => MapToWebApiVersionModel(version))
      : undefined

    return webApiModel;
  }

  function MapToWebApiVersionModel(stockApiVersionModel) {
    var webApiModel = angular.copy(stockApiVersionModel);

    webApiModel.validUntil = stockApiVersionModel.validTo
    webApiModel.yeildQuantity = stockApiVersionModel.yieldQuantity
    webApiModel.yeildUnitId = stockApiVersionModel.yieldUnitId
    webApiModel.yeildUnitName = stockApiVersionModel.yieldUnitName
    webApiModel.yeildUnitRatio = stockApiVersionModel.yieldUnitRatio
    webApiModel.lines = stockApiVersionModel.lines.map(line => MapToWebApiLineModel(line))

    return webApiModel;
  }

  function MapToWebApiLineModel(stockApiLineModel) {
    var webApiModel = angular.copy(stockApiLineModel);
      
    webApiModel.stockDeletedAt = stockApiLineModel.deletedAt
    webApiModel.stockItemId = stockApiLineModel.itemId
    webApiModel.stockItemName = stockApiLineModel.itemName
    
    return webApiModel;
  }

  return {
    getAll: getAll,
    getAllStockApi,
    getAllActive: getAllActive,
    get: get,
    getStockApi,
    getCostAndUnit: getCostAndUnit,
    getVersion: getVersion,
    getVersionStockApi,
    getImages: getImages,
    save: save,
    remove: remove,
    restore: restore,
    removeVersion: removeVersion
  };
}]);
